import { InvestorInfo } from "../../types/investorInformation.interface";
import taxCenterGw from "../taxCenterGw";

export const getInvestorInformation = async (): Promise<InvestorInfo> => {
  const { data } = await taxCenterGw.get<InvestorInfo>("/info/investor", {});
  return data;
};
